/**
 * Hermes Design Tokens - Color Palette
 * Theme: "Mercury's Digital Messenger"
 * Primary: Deep Blue (trust, communication, digital)
 * Secondary: Sky Blue (energy, speed)
 */

export const colors = {
  // Primary palette - Deep Blue
  deepBlue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#93C5FD',
    400: '#60A5FA',
    500: '#2C5AA0', // Main primary
    600: '#1A3D6F',
    700: '#1E3A8A',
    800: '#1E40AF',
    900: '#0C1E3D',
  },

  // Secondary palette - Sky Blue
  skyBlue: {
    50: '#F0F9FF',
    100: '#E0F2FE',
    200: '#BAE6FD',
    300: '#7DD3FC',
    400: '#38BDF8',
    500: '#0EA5E9', // Main secondary
    600: '#0284C7',
    700: '#0369A1',
    800: '#075985',
    900: '#0C4A6E',
  },

  // Module colors
  courier: {
    main: '#F59E0B',
    light: '#FBBF24',
    dark: '#D97706',
    contrast: '#1A3D6F',
  },

  santa: {
    main: '#DC2626',    // Christmas red (Santa's suit)
    light: '#F87171',   // Light red (festive accent)
    dark: '#991B1B',    // Deep red (rich Christmas)
    contrast: '#FFFFFF', // White (snow)
  },

  email: {
    main: '#3B82F6',
    light: '#60A5FA',
    dark: '#2563EB',
    contrast: '#FFFFFF',
  },

  user: {
    main: '#10B981',    // Emerald green (user profile)
    light: '#34D399',   // Light green (accessible)
    dark: '#059669',    // Deep green (professional)
    contrast: '#FFFFFF', // White text
  },

  // Editorial colors
  editorial: {
    warmWhite: '#F8FAFC',
    inkBlack: '#0F172A',
    paperGray: '#E2E8F0',
    accentElectric: '#06B6D4',
  },

  // Semantic colors
  success: {
    main: '#10B981',
    light: '#34D399',
    dark: '#059669',
  },

  error: {
    main: '#EF4444',
    light: '#F87171',
    dark: '#DC2626',
  },

  warning: {
    main: '#F59E0B',
    light: '#FBBF24',
    dark: '#D97706',
  },

  info: {
    main: '#3B82F6',
    light: '#60A5FA',
    dark: '#2563EB',
  },
};
